import { API } from 'src/services';

const apiClient = API.create();

export default apiClient;
